import React from 'react'
let input = document.querySelectorAll('#input-tap');

const Contact = () => {
  
  return (
    <>
      <div className="contact-me" id="contact">
        <h1 className="contact-text">Contact me</h1>
        <p className='text-center'>Please fill out the form and describe your project needs and I'll contact you as soon as possible.</p>
        <form action="#" method="post" target='_blank'>
          <div className="contact-mail px-5 mx-5 row">
            <div className="col-xxl-6 col-xl-6 lg-6 col-md-12 col-sm-12 col-12 about-me">
              <input type="text" name="name" className="form-controls" id="name input-tap" placeholder="Name" />
              <input type="tel" name="phone" className="form-controls" id="phone input-tap" placeholder="Phone Number" />
              <input type="email" name="email" className="form-controls" id="email input-tap" placeholder="Email" />
              <input type="text" name="subject" className="form-controls" id="subject input-tap" placeholder="Subject" />
            </div>
            <div className="col-xxl-6 col-xl-6 lg-6 col-md-12 col-sm-12 col-12 about-project">
              <textarea name="you-project" className="form-controls" id="yuo-project" rows="8" placeholder="Please describe should your project"></textarea>
              <input type="submit" className="btn btn-outline-warning form-control my-3" value="contact me" />
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default Contact